exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardSubcontractorsTable-7095e{margin-bottom:40px;padding:16px 24px;background-color:#fff}.redCell-225b9{background-color:rgba(222,96,96,.25)}", ""]);

// Exports
exports.locals = {
	"dashboardSubcontractorsTable": "dashboardSubcontractorsTable-7095e",
	"redCell": "redCell-225b9"
};